import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, passwordRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import firebaseApp, { auth } from '../../../firebase-init';
import firebase from 'firebase/app';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  const { t, i18n } = useTranslation();

  let history = useHistory();
  let location = useLocation();

  const [formInputs, setFormInputs] = useState({ email: '', password: '', passwordConfirmation: '', conditions_check: false });
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);

  const firebaseRegistration = async () => {
    setLoading(true);
    auth
      .createUserWithEmailAndPassword(formState.inputValues.email, formState.inputValues.password)
      .then(async (result) => {
        const tokenId = await result.user.getIdToken();
        if (result.additionalUserInfo.isNewUser) {
          // Set a custom claim to mark this user as "pending registration"
          // This will be removed once personal information is successfully saved
          await result.user.getIdToken(true);
          history.push('/personal-information');
        }
        setLoading(false);
      })
      .catch((error) => {
        errorsHandler(error.code);

        setLoading(false);
      });
  };

  const errorsHandler = (error) => {
    setLoading(false);

    switch (error) {
      case 'auth/user-not-found':
        handleErrorsServer(['ERROR_EMAIL_PATTERN']);
        break;

      case 'auth/wrong-password':
        handleErrorsServer(['ERROR_PASSWORD_PATTERN']);
        break;

      case 'auth/invalid-email':
        handleErrorsServer(['ERROR_EMAIL_PATTERN']);
        break;

      case 'auth/email-already-in-use':
        handleErrorsServer(['ERROR_EMAIL_ALREADY_USED']);

        break;

      case 'auth/weak-password':
        handleErrorsServer(['ERROR_PASSWORD_MIN']);
        break;

      case 'auth/popup-closed-by-user':
        setErrors('ERROR_AUTHENTICATION_CANCELLED');
        break;

      default:
        setErrors('SOMETHING_WENT_WRONG');
        break;
    }
  };

  const firebaseProviderRegistration = async (provider_) => {
    setLoading(true);
    let provider;
    switch (provider_) {
      case 'facebook':
        provider = new firebase.auth.FacebookAuthProvider();
        provider.addScope('email');

        break;

      case 'google':
        provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('email');
        break;

      default:
        // setErrors('login.errors.authentication-error');
        setErrors('login.errors.authentication-error');
        break;
    }

    auth
      .signInWithPopup(provider)
      .then(async function (result) {
        const tokenId = await result.user.getIdToken();

        if (result.additionalUserInfo.isNewUser) {
          history.push('/personal-information');
        }
        setLoading(false);
      })
      .catch((error) => {
        errorsHandler(error.code);
      });
  };

  const inputValues = {
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    password: { value: '', validate: { required: true, min: 8, pattern: passwordRegex } },
    password_confirm: { value: '', validate: { required: true } },
    conditions: { value: true, validate: { required: true } },
  };

  const { formState, submitHandler, field, handleErrorsServer } = FormState(inputValues, firebaseRegistration);

  return {
    field,
    submitHandler,
    firebaseProviderRegistration,
    formInputs,
    setFormInputs,
    errors,
    loading,
  };
};

export default useForm;
